module.exports = __webpack_public_path__ + "img/6344d5e31ce0f564a64bc14c2e49b967.png";